var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.305 70.5145C57.1366 70.5145 70.7812 56.8699 70.7812 40.0383C70.7812 23.2068 57.1366 9.56214 40.305 9.56214C23.4735 9.56214 9.82886 23.2068 9.82886 40.0383C9.82886 56.8699 23.4735 70.5145 40.305 70.5145Z",
    fill: "url(#paint0_radial)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M40.305 70.5145C57.1366 70.5145 70.7812 56.8699 70.7812 40.0383C70.7812 23.2068 57.1366 9.56214 40.305 9.56214C23.4735 9.56214 9.82886 23.2068 9.82886 40.0383C9.82886 56.8699 23.4735 70.5145 40.305 70.5145Z",
    fill: "url(#paint1_radial)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6574 28.9144C33.8289 27.6953 32.6098 26.762 30.3622 26.4763C28.4384 26.2287 24.1146 26.7049 20.7051 30.0382C20.0765 30.6477 20.8575 31.143 21.4289 30.762C23.4098 29.4858 28.4384 28.1906 32.0955 29.0858C33.5813 29.4668 33.6574 28.9144 33.6574 28.9144Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9527 28.9144C46.7813 27.6953 48.0003 26.762 50.2479 26.4763C52.1717 26.2287 56.4956 26.7049 59.9051 30.0382C60.5336 30.6477 59.7527 31.143 59.1813 30.762C57.2003 29.4858 52.1717 28.1906 48.5146 29.0858C47.0098 29.4668 46.9527 28.9144 46.9527 28.9144Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.305 70.5145C57.1366 70.5145 70.7812 56.8699 70.7812 40.0383C70.7812 23.2068 57.1366 9.56214 40.305 9.56214C23.4735 9.56214 9.82886 23.2068 9.82886 40.0383C9.82886 56.8699 23.4735 70.5145 40.305 70.5145Z",
    fill: "url(#paint4_radial)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M40.305 70.5145C57.1366 70.5145 70.7812 56.8699 70.7812 40.0383C70.7812 23.2068 57.1366 9.56214 40.305 9.56214C23.4735 9.56214 9.82886 23.2068 9.82886 40.0383C9.82886 56.8699 23.4735 70.5145 40.305 70.5145Z",
    fill: "url(#paint5_radial)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M40.305 70.5145C57.1366 70.5145 70.7812 56.8699 70.7812 40.0383C70.7812 23.2068 57.1366 9.56214 40.305 9.56214C23.4735 9.56214 9.82886 23.2068 9.82886 40.0383C9.82886 56.8699 23.4735 70.5145 40.305 70.5145Z",
    fill: "url(#paint6_radial)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.1716 61.4096C38.0113 61.4096 41.124 58.2969 41.124 54.4572C41.124 50.6175 38.0113 47.5048 34.1716 47.5048C30.3319 47.5048 27.2192 50.6175 27.2192 54.4572C27.2192 58.2969 30.3319 61.4096 34.1716 61.4096Z",
    fill: "url(#paint7_radial)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9333 57.9999C42.0063 57.9999 42.8762 56.8742 42.8762 55.4856C42.8762 54.097 42.0063 52.9714 40.9333 52.9714C39.8603 52.9714 38.9905 54.097 38.9905 55.4856C38.9905 56.8742 39.8603 57.9999 40.9333 57.9999Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68 45.7526C68.1142 46.8002 67.4285 48.6669 66.3428 49.8859C65.5238 50.8193 64.3809 51.1812 63.2381 50.9717C63.0095 50.9336 62.8 50.8764 62.5714 50.7812C61.1047 50.1717 59.7142 49.105 58.2285 49.3336L48.8 50.705C47.5428 50.8955 46.3238 51.2193 45.1428 51.6955L40.1904 54.2669L40.4571 56.0574L45.9238 57.105C47.2 57.2383 48.4571 57.2002 49.7142 57.0288L61.5809 55.2955L64.9904 54.1907L69.4095 50.8383C70.419 49.9812 70.4 48.0955 69.3714 47.124L68 45.7526Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0761 50.8382C47.0857 51.0286 46.1142 51.3143 45.1619 51.7143L40.2095 54.2858L40.4761 56.0763L45.9428 57.1239C46.9523 57.2191 47.9809 57.2191 48.9714 57.1239C48.4761 57.0286 47.9047 55.7334 47.6761 54.1144C47.4476 52.4572 47.619 51.0667 48.0761 50.8382Z",
    fill: "url(#paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68 45.7526C68.1142 46.8002 67.4285 48.6669 66.3428 49.8859C65.5238 50.8193 64.3809 51.1812 63.238 50.9717C63.0095 50.9336 62.8 50.8764 62.5714 50.7812C61.1047 50.1717 59.7142 49.105 58.2285 49.3336L48.8 50.705C47.5428 50.8955 46.3238 51.2193 45.1428 51.6955L40.1904 54.2669L40.4571 56.0574L45.9238 57.105C47.2 57.2383 48.4571 57.2002 49.7142 57.0288L60.9714 55.3907L64.2857 54.705L69.3904 50.8574C70.4 50.0002 70.3809 48.1145 69.3523 47.1431L68 45.7526Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9905 55.3907C67.3333 54.4764 73.6 52.8764 72.2476 44.5335C71.2762 38.4764 62.0571 37.924 61.5429 42.1716C62.2095 41.4478 63.1809 39.9812 63.8857 39.9621C67.1809 39.8478 68.1905 43.6383 68.2476 45.6764C68.3619 50.7812 64.1333 54.9335 60.9905 55.3907Z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9141 42.9715C67.7903 43.2572 68.0189 44.6477 67.9998 45.7334C67.9998 45.7334 68.2475 46.362 68.076 46.6286L68.2094 46.381C68.2094 46.362 68.2284 45.6762 68.2284 45.6572C68.1713 43.6191 67.1236 39.7905 63.8665 39.9429C60.8951 40.0953 61.1237 44.4 61.9427 45.6L62.3999 46.3429L65.9237 45.6953C65.4665 43.3715 66.2094 42.7429 66.9141 42.9715Z",
    fill: "url(#paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4475 43.7905C61.5999 44.9905 62.0951 46.1334 62.6094 46.0572C63.1237 45.981 63.3332 44.8191 63.238 44.1334L67.6761 44.8001C67.7713 45.4286 67.5808 46.4953 67.1046 46.5715L62.6666 46.4953C61.638 46.4763 61.4475 44.3239 61.4475 43.7905Z",
    fill: "url(#paint14_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9716 55.4097C40.3811 59.8668 36.7811 60.8382 37.5049 59.562C38.4573 57.8287 38.6858 56.6859 38.8954 55.143C39.1049 53.6001 39.1811 52.4382 38.7239 50.5144C38.362 49.0859 41.562 50.9525 40.9716 55.4097Z",
    fill: "#643800"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7048 50.5145C39.181 52.4383 39.0857 53.6002 38.8762 55.143C38.6667 56.6859 38.4381 57.8287 37.4857 59.5621C37.2381 60.0192 37.5048 60.1907 38 60.0383C37.981 60.0383 37.5048 59.9049 37.9429 59.3145C38.6095 58.4383 39.6381 57.143 39.8857 55.2954C40.1333 53.4287 39.4857 51.924 39.0667 50.8954C38.8191 50.2097 39.3143 50.2097 39.3143 50.2097C38.8952 49.924 38.5905 50.0192 38.7048 50.5145Z",
    fill: "url(#paint15_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M68 45.7526C68.1142 46.8002 67.4285 48.6669 66.3428 49.8859C65.5238 50.8193 64.3809 51.1812 63.238 50.9717C63.0095 50.9336 62.8 50.8764 62.5714 50.7812C61.1047 50.1717 59.7142 49.105 58.2285 49.3336L48.8 50.705C47.5428 50.8955 46.3238 51.2193 45.1428 51.6955L40.1904 54.2669L40.4571 56.0574L45.9238 57.105C47.2 57.2383 48.4571 57.2002 49.7142 57.0288L60.9714 55.3907L64.2857 54.705L69.3904 50.8574C70.4 50.0002 70.3809 48.1145 69.3523 47.1431L68 45.7526Z",
    fill: "url(#paint16_radial)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M60.9905 55.3907C67.3333 54.4764 73.6 52.8764 72.2476 44.5335C71.2762 38.4764 62.0571 37.924 61.5429 42.1716C62.2095 41.4478 63.1809 39.9812 63.8857 39.9621C67.1809 39.8478 68.1905 43.6383 68.2476 45.6764C68.3619 50.7812 64.1333 54.9335 60.9905 55.3907Z",
    fill: "url(#paint17_radial)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5334 15.1239C26.8192 14.9906 26.8382 14.5906 26.5525 14.4382L23.7525 12.9715L6.99057 4.26677C6.64772 4.09534 5.27629 3.48582 3.73343 4.78106C2.09533 6.20963 2.47629 7.29534 2.59057 7.6382L11.2953 30.1715C11.4858 30.6858 12.2096 30.6668 12.4001 30.1525C14.5334 24.0953 23.162 16.6858 26.5334 15.1239Z",
    fill: "url(#paint18_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7716 12.9714L20.3049 11.1809C19.0478 10.6095 8.49538 18.5904 8.76205 23.5428L10.7811 28.7619C8.36205 22.5523 22.0763 12.0952 23.7716 12.9714Z",
    fill: "url(#paint19_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.781 9.37168L16.0001 8.95263L13.3144 7.56216C12.1906 7.46692 5.90485 12.286 5.65723 15.5431L7.33342 19.8479C6.95246 15.3336 15.6382 8.76216 16.781 9.37168Z",
    fill: "url(#paint20_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20002 4.39992C6.20954 4.76182 3.63812 6.72373 2.91431 8.43801L4.66669 12.9904C3.60002 10.2094 9.16192 6.01897 10.3429 6.01897L7.20002 4.39992Z",
    fill: "url(#paint21_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M26.5334 15.1239C26.8192 14.9906 26.8382 14.5906 26.5525 14.4382L23.7525 12.9715L6.99057 4.26677C6.64772 4.09534 5.27629 3.48582 3.73343 4.78106C2.09533 6.20963 2.47629 7.29534 2.59057 7.6382L11.2953 30.1715C11.4858 30.6858 12.2096 30.6668 12.4001 30.1525C14.5334 24.0953 23.162 16.6858 26.5334 15.1239Z",
    fill: "url(#paint22_radial)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M26.5334 15.1239C26.8192 14.9906 26.8382 14.5906 26.5525 14.4382L23.7525 12.9715L6.99057 4.26677C6.64772 4.09534 5.27629 3.48582 3.73343 4.78106C2.09533 6.20963 2.47629 7.29534 2.59057 7.6382L11.2953 30.1715C11.4858 30.6858 12.2096 30.6668 12.4001 30.1525C14.5334 24.0953 23.162 16.6858 26.5334 15.1239Z",
    fill: "url(#paint23_radial)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M26.5334 15.1239C26.8192 14.9906 26.8382 14.5906 26.5525 14.4382L23.7525 12.9715L6.99057 4.26677C6.64772 4.09534 5.27629 3.48582 3.73343 4.78106C2.09533 6.20963 2.47629 7.29534 2.59057 7.6382L11.2953 30.1715C11.4858 30.6858 12.2096 30.6668 12.4001 30.1525C14.5334 24.0953 23.162 16.6858 26.5334 15.1239Z",
    fill: "url(#paint24_radial)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0573 35.1237C29.943 33.8095 27.2192 33.9618 25.2382 35.4476C24.2287 36.2095 23.2382 37.3714 22.6478 39.1809C22.5525 39.4856 22.4763 39.8095 22.4573 40.1333C22.4192 40.7809 22.8763 41.3714 23.6001 40.6856C29.2382 35.3714 33.1811 40.838 33.1811 40.838C33.943 41.3904 34.724 40.2476 34.5716 39.1809C34.5335 38.8761 34.4954 38.5523 34.4002 38.2666C33.9621 36.7237 33.0287 35.7523 32.0573 35.1237Z",
    fill: "url(#paint25_radial)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4001 38.2669C34.1906 37.6193 33.9239 37.086 33.6382 36.6288C33.1811 35.9812 32.6287 35.505 32.0573 35.1431C29.943 33.8288 27.2192 33.9812 25.2382 35.4669C24.2287 36.2288 23.2382 37.3907 22.6477 39.2003C22.5906 39.3717 22.5525 39.5622 22.5144 39.7526C22.5144 39.7526 22.5144 39.7526 22.5144 39.7717C24.9906 35.905 28.5715 35.6384 28.5715 35.6384C28.5715 35.6384 32.1144 35.3336 34.5144 38.8003C34.4763 38.6098 34.4573 38.4384 34.4001 38.2669Z",
    fill: "url(#paint26_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5525 35.1237C50.6668 33.8095 53.3906 33.9618 55.3716 35.4476C56.3811 36.2095 57.3716 37.3714 57.9621 39.1809C58.0573 39.4856 58.1335 39.8095 58.1526 40.1333C58.1906 40.7809 57.7335 41.3714 57.0097 40.6856C51.3716 35.3714 47.4287 40.838 47.4287 40.838C46.6668 41.3904 45.8859 40.2476 46.0383 39.1809C46.0764 38.8761 46.1144 38.5523 46.2097 38.2666C46.6287 36.7237 47.5621 35.7523 48.5525 35.1237Z",
    fill: "url(#paint27_radial)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1907 38.2669C46.4002 37.6193 46.6669 37.086 46.9526 36.6288C47.4098 35.9812 47.9621 35.505 48.5336 35.1431C50.6479 33.8288 53.3717 33.9812 55.3526 35.4669C56.3621 36.2288 57.3526 37.3907 57.9431 39.2003C58.0002 39.3717 58.0383 39.5622 58.0764 39.7526C58.0764 39.7526 58.0764 39.7526 58.0764 39.7717C55.6002 35.905 52.0193 35.6384 52.0193 35.6384C52.0193 35.6384 48.4764 35.3336 46.0764 38.8003C46.1145 38.6098 46.1526 38.4193 46.1907 38.2669Z",
    fill: "url(#paint28_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4287 57.1809C46.9525 57.0476 46.4573 55.8095 46.2287 54.2857C46.0192 52.8381 46.1525 51.5809 46.5144 51.2381C46.0573 51.3714 45.6001 51.5428 45.162 51.7143L45.1049 51.7333C44.8192 52.1524 44.6668 53.2 44.8382 54.4571C45.0096 55.6762 45.4668 56.6857 45.8477 57.0857L45.943 57.1047C46.4382 57.1619 46.9334 57.1809 47.4287 57.1809Z",
    fill: "url(#paint29_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M16.0761 31.9048C17.0666 34.762 14.5713 35.5048 15.3904 37.3525L18.1713 36.6286C17.3523 34.781 19.5237 34.0763 18.6475 31.1239L16.0761 31.9048Z",
    fill: "url(#paint30_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M63.1427 22.6668C59.3331 24.8192 58.3617 20.3811 55.7903 21.3716L56.5903 25.2001C59.1427 24.2287 60.2284 28.3811 64.0379 26.2287L63.1427 22.6668Z",
    fill: "url(#paint31_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M32.1713 18.2475C32.6026 18.2475 32.9523 17.8979 32.9523 17.4666C32.9523 17.0353 32.6026 16.6856 32.1713 16.6856C31.74 16.6856 31.3904 17.0353 31.3904 17.4666C31.3904 17.8979 31.74 18.2475 32.1713 18.2475Z",
    fill: "url(#paint32_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M52.2094 17.9049C52.6407 17.9049 52.9904 17.5553 52.9904 17.124C52.9904 16.6927 52.6407 16.343 52.2094 16.343C51.7781 16.343 51.4285 16.6927 51.4285 17.124C51.4285 17.5553 51.7781 17.9049 52.2094 17.9049Z",
    fill: "url(#paint33_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M66.3046 36.6475C66.7359 36.6475 67.0856 36.2978 67.0856 35.8665C67.0856 35.4352 66.7359 35.0855 66.3046 35.0855C65.8733 35.0855 65.5237 35.4352 65.5237 35.8665C65.5237 36.2978 65.8733 36.6475 66.3046 36.6475Z",
    fill: "url(#paint34_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M17.4284 47.9239C17.8597 47.9239 18.2094 47.5742 18.2094 47.1429C18.2094 46.7116 17.8597 46.362 17.4284 46.362C16.9971 46.362 16.6475 46.7116 16.6475 47.1429C16.6475 47.5742 16.9971 47.9239 17.4284 47.9239Z",
    fill: "url(#paint35_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M54.5522 64.0191C54.9835 64.0191 55.3332 63.6695 55.3332 63.2382C55.3332 62.8069 54.9835 62.4572 54.5522 62.4572C54.1209 62.4572 53.7712 62.8069 53.7712 63.2382C53.7712 63.6695 54.1209 64.0191 54.5522 64.0191Z",
    fill: "url(#paint36_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M52.1713 45.0094C52.6026 45.0094 52.9523 44.6598 52.9523 44.2285C52.9523 43.7972 52.6026 43.4475 52.1713 43.4475C51.74 43.4475 51.3904 43.7972 51.3904 44.2285C51.3904 44.6598 51.74 45.0094 52.1713 45.0094Z",
    fill: "url(#paint37_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M44.3809 18.6476C44.3047 17.4095 44.1904 16.1143 44.038 14.7619C39.238 17.7714 37.4094 21.4286 37.4094 21.4286L38.838 24.5143C40.3428 21.6571 42.838 19.6762 44.3809 18.6476Z",
    fill: "url(#paint38_radial)"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6571 30.2289C16.6476 33.086 14.1524 33.8289 14.9714 35.6765L17.7524 34.9527C16.9333 33.1051 19.1048 32.4003 18.2286 29.4479L15.6571 30.2289Z",
    fill: "url(#paint39_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1432 21.124C59.3336 23.2764 58.3622 18.8383 55.7908 19.8288L56.5908 23.6574C59.1432 22.6859 60.2289 26.8383 64.0384 24.6859L63.1432 21.124Z",
    fill: "url(#paint40_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5524 16.7621C64.9837 16.7621 65.3334 16.4124 65.3334 15.9811C65.3334 15.5498 64.9837 15.2001 64.5524 15.2001C64.1211 15.2001 63.7715 15.5498 63.7715 15.9811C63.7715 16.4124 64.1211 16.7621 64.5524 16.7621Z",
    fill: "url(#paint41_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1716 17.1051C32.6029 17.1051 32.9525 16.7554 32.9525 16.3241C32.9525 15.8928 32.6029 15.5432 32.1716 15.5432C31.7403 15.5432 31.3906 15.8928 31.3906 16.3241C31.3906 16.7554 31.7403 17.1051 32.1716 17.1051Z",
    fill: "url(#paint42_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2097 16.7621C52.641 16.7621 52.9906 16.4124 52.9906 15.9811C52.9906 15.5498 52.641 15.2001 52.2097 15.2001C51.7784 15.2001 51.4287 15.5498 51.4287 15.9811C51.4287 16.4124 51.7784 16.7621 52.2097 16.7621Z",
    fill: "url(#paint43_linear)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3049 35.505C66.7362 35.505 67.0858 35.1553 67.0858 34.724C67.0858 34.2927 66.7362 33.9431 66.3049 33.9431C65.8736 33.9431 65.5239 34.2927 65.5239 34.724C65.5239 35.1553 65.8736 35.505 66.3049 35.505Z",
    fill: "url(#paint44_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2573 47.0288C17.6886 47.0288 18.0382 46.6792 18.0382 46.2479C18.0382 45.8166 17.6886 45.4669 17.2573 45.4669C16.826 45.4669 16.4763 45.8166 16.4763 46.2479C16.4763 46.6792 16.826 47.0288 17.2573 47.0288Z",
    fill: "url(#paint45_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0764 43.9433C52.5077 43.9433 52.8573 43.5936 52.8573 43.1623C52.8573 42.731 52.5077 42.3814 52.0764 42.3814C51.6451 42.3814 51.2954 42.731 51.2954 43.1623C51.2954 43.5936 51.6451 43.9433 52.0764 43.9433Z",
    fill: "url(#paint46_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0668 58.1906C11.4982 58.1906 11.8478 57.841 11.8478 57.4097C11.8478 56.9784 11.4982 56.6287 11.0668 56.6287C10.6355 56.6287 10.2859 56.9784 10.2859 57.4097C10.2859 57.841 10.6355 58.1906 11.0668 58.1906Z",
    fill: "url(#paint47_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7812 15.924C44.705 14.6859 44.5908 13.3907 44.4384 12.0383C39.6384 15.0479 37.8098 18.705 37.8098 18.705L39.2384 21.7907C40.7431 18.9526 43.2384 16.9526 44.7812 15.924Z",
    fill: "url(#paint48_linear)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7335 52.6475C30.1716 61.1047 23.2573 63.2952 21.1812 63.7713C22.2669 64.6475 23.4097 65.4475 24.6288 66.1713C28.4002 64.5904 34.6097 60.6094 32.5145 51.8285C31.4859 52.0952 30.5526 52.3618 29.7335 52.6475Z",
    fill: "url(#paint49_radial)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7525 51.1999C28.2668 61.1428 18.6096 62.438 18.6096 62.438L19.962 65.619C19.962 65.619 33.4668 62.7428 30.5334 50.3999C29.5049 50.6475 28.5715 50.9142 27.7525 51.1999Z",
    fill: "url(#paint50_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.3014 27.6832) scale(36.7656)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB92E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.3014 27.6832) scale(28.9251)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 27.0063,
    y1: 30.0843,
    x2: 27.4334,
    y2: 26.9015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 53.5934,
    y1: 30.0834,
    x2: 53.1663,
    y2: 26.9006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.4132 20.3184) rotate(-45.5348) scale(23.3841 9.60696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB672A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3025,
    stopColor: "#E36521",
    stopOpacity: 0.3422
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    stopColor: "#CC600A",
    stopOpacity: 0.0897045
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9589,
    stopColor: "#C25E00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.6815 47.616) rotate(-2.7703) scale(12.819 10.143)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1995,
    stopColor: "#F94C0E",
    stopOpacity: 0.8005
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7145,
    stopColor: "#EC4A2E",
    stopOpacity: 0.2855
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74A3A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.6198 57.0298) rotate(-0.40159) scale(20.3819 4.6267)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4400",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5833,
    stopColor: "#894D00",
    stopOpacity: 0.2069
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#975500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.3788 55.7751) rotate(4.55396) scale(7.19701 5.08873)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 38.9796,
    y1: 55.4789,
    x2: 42.8729,
    y2: 55.4789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 55.1748,
    y1: 51.5834,
    x2: 56.5166,
    y2: 60.7917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF40BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8932,
    stopColor: "#7000A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 43.8612,
    y1: 50.6956,
    x2: 44.7811,
    y2: 57.0087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2544,
    stopColor: "#D1F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17BBFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 57.496,
    y1: 52.0159,
    x2: 71.9956,
    y2: 45.7927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7000A3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2242,
    stopColor: "#530078",
    stopOpacity: 0.2242
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5925,
    stopColor: "#260038",
    stopOpacity: 0.5925
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8613,
    stopColor: "#0B000F",
    stopOpacity: 0.8613
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 69.9703,
    y1: 61.7013,
    x2: 65.5709,
    y2: 46.2574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1488,
    stopColor: "#27002D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4631,
    stopColor: "#760086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7193,
    stopColor: "#B000C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    stopColor: "#D300F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E100FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 65.5246,
    y1: 37.664,
    x2: 64.0816,
    y2: 51.8546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1488,
    stopColor: "#27002D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4631,
    stopColor: "#760086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7193,
    stopColor: "#B000C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    stopColor: "#D300F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E100FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 65.1951,
    y1: 48.8753,
    x2: 64.5884,
    y2: 44.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7000A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4469,
    stopColor: "#A900D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8117,
    stopColor: "#D200F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E100FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 36.532,
    y1: 54.8277,
    x2: 39.7871,
    y2: 55.2627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9829 52.1146) rotate(-8.28692) scale(11.0217 1.22912)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.361 43.6091) rotate(77.7176) scale(5.54615 1.24116)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 21.9461,
    y1: 7.80268,
    x2: 4.29013,
    y2: 20.1898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2544,
    stopColor: "#D1F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17BBFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 23.4764,
    y1: 12.6762,
    x2: 8.05308,
    y2: 25.5705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF40BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7456,
    stopColor: "#7000A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 16.0229,
    y1: 8.51114,
    x2: 5.29391,
    y2: 17.4808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF40BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7456,
    stopColor: "#7000A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 9.70573,
    y1: 5.31891,
    x2: 2.93982,
    y2: 10.9754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF40BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7456,
    stopColor: "#7000A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.49277 16.9167) rotate(65.3021) scale(12.647 3.11471)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#440063",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#420061",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0325 11.1614) rotate(31.2018) scale(12.6468 3.11512)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.1242 27.5642) rotate(30.2004) scale(15.606 15.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#440063",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#420061",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.5848 37.8158) rotate(175.474) scale(4.70179 3.33396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 29.0423,
    y1: 31.8984,
    x2: 28.669,
    y2: 37.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.0077 37.8157) rotate(4.52557) scale(4.70179 3.33396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 51.5509,
    y1: 31.8984,
    x2: 51.9241,
    y2: 37.0159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 45.733,
    y1: 52.7939,
    x2: 46.4905,
    y2: 58.5833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF40BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8932,
    stopColor: "#7000A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.4276 20.1193) scale(68.6114)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4400",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5833,
    stopColor: "#894D00",
    stopOpacity: 0.2069
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#975500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5621 13.7082) rotate(0.0419929) scale(93.3525 93.2905)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4400",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5833,
    stopColor: "#894D00",
    stopOpacity: 0.2069
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#975500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.6657 17.2382) scale(68.6115)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4400",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5833,
    stopColor: "#894D00",
    stopOpacity: 0.2069
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#975500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.6657 17.2384) scale(68.6115)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4400",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5833,
    stopColor: "#894D00",
    stopOpacity: 0.2069
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#975500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.6657 17.2381) scale(68.6115)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4400",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5833,
    stopColor: "#894D00",
    stopOpacity: 0.2069
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#975500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.2181 18.286) scale(68.6115)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4400",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5833,
    stopColor: "#894D00",
    stopOpacity: 0.2069
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#975500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.6655 17.2383) scale(68.6118 68.6115)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4400",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5833,
    stopColor: "#894D00",
    stopOpacity: 0.2069
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#975500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.1419 14.1431) scale(68.6115 68.6112)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4400",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5833,
    stopColor: "#894D00",
    stopOpacity: 0.2069
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#975500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.4618 27.3772) rotate(-28.5684) scale(94.9673 94.8887)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4400",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5833,
    stopColor: "#894D00",
    stopOpacity: 0.2069
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#975500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 17.6686,
    y1: 34.3325,
    x2: 15.4752,
    y2: 30.6745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4E0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 68.6915,
    y1: 24.2906,
    x2: 55.9634,
    y2: 21.8981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008EE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 59.9646,
    y1: 15.1076,
    x2: 69.0034,
    y2: 16.8881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E81CA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 36.7304,
    y1: 16.2253,
    x2: 27.3392,
    y2: 16.4561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E81CA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 51.8993,
    y1: 12.3591,
    x2: 52.2167,
    y2: 16.1686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008EE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 67.6065,
    y1: 36.1454,
    x2: 64.4472,
    y2: 32.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E81CA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 15.6724,
    y1: 45.9803,
    x2: 17.8922,
    y2: 46.3979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2544,
    stopColor: "#9F00E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7000A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 49.58,
    y1: 46.4366,
    x2: 53.834,
    y2: 40.8493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008EE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 9.97252,
    y1: 57.061,
    x2: 15.0625,
    y2: 58.8834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4E0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 56.1297,
    y1: 6.98481,
    x2: 35.8587,
    y2: 21.1521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E81CA2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.30806 50.5101) scale(32.404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4400",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5833,
    stopColor: "#894D00",
    stopOpacity: 0.2069
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#975500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: 28.1642,
    y1: 45.1344,
    x2: 19.8987,
    y2: 78.6053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78174"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3893,
    stopColor: "#8800C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3640FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParty);
export default __webpack_public_path__ + "static/media/party.e60407348b3432cb5d4d6f0b583e95c0.svg";
export { ForwardRef as ReactComponent };